import _ from 'lodash'

import DataType from 'scoreboard/datasets/model/data-type'
const { NUMBER, PERCENT, CURRENCY, TEXT, YES_NO, DATE, TIME, DATE_TIME, CALENDAR_PERIOD, ROLLUP, DATASET_LINK, CLUSTER, CONTINENT, COUNTRY, STATE_PROVINCE, COUNTY, POSTAL_CODE, CITY, FILE } = DataType

/**
 * The data types for dataset fields.  These are in a different order than
 * num.dataTypes, and also use different text (Datasets calls 'number' "Number",
 * and scorecards call it "Standard")
 */
const dataTypes = [
	{
		id: TEXT,
		icon: TEXT,
		label: 'dashboards.dashboard.text',
		group: 'headerless'
	}, {
		id: NUMBER,
		icon: NUMBER,
		label: 'scorecards.node.metric.dataType.number',
		group: 'datasets.datatype.groups.numeric'
	}, {
		id: PERCENT,
		icon: PERCENT,
		label: 'scorecards.node.metric.dataType.percentage',
		group: 'datasets.datatype.groups.numeric'
	}, {
		id: CURRENCY,
		icon: CURRENCY,
		label: 'scorecards.node.metric.dataType.currency',
		group: 'datasets.datatype.groups.numeric'
	}, {
		id: DATE,
		icon: 'calendar',
		label: 'common.date',
		group: 'datasets.datatype.groups.dateTime'
	}, {
		id: TIME,
		icon: 'clock',
		label: 'common.time',
		group: 'datasets.datatype.groups.dateTime'
	}, {
		id: DATE_TIME,
		icon: DATE_TIME,
		label: 'common.dateTime',
		group: 'datasets.datatype.groups.dateTime'
	}, {
		id: CALENDAR_PERIOD,
		icon: 'calendar',
		label: 'common.calendar.calendarPeriod',
		group: 'datasets.datatype.groups.dateTime'
	},{
		id: YES_NO,
		icon: 'yes-no-data-type',
		label: 'admin.scorecards.metric.scoringType.yesNo',
		group: 'headerless'
	}, {
		id: ROLLUP,
		icon: 'rollup-tree',
		label: 'datasets.dataType.rollupTree',
		group: 'datasets.datatype.groups.advanced'
	}, {
		id: DATASET_LINK,
		icon: DATASET_LINK,
		label: 'datasets.datatype.link',
		group: 'datasets.datatype.groups.advanced'
	}, {
		id: CONTINENT,
		icon: 'geography',
 		label: 'datasets.field.fieldType.continent',
		group: 'datasets.datatype.groups.geographic'
	}, {
		id: COUNTRY,
		icon: 'geography',
 		label: 'datasets.field.fieldType.country',
		group: 'datasets.datatype.groups.geographic'
	}, {
		id: STATE_PROVINCE,
		icon: 'geography',
 		label: 'datasets.field.fieldType.stateProvince',
		group: 'datasets.datatype.groups.geographic'
	}, {
		id: COUNTY,
		icon: 'geography',
 		label: 'datasets.field.fieldType.county',
		group: 'datasets.datatype.groups.geographic'
	}, {
		id: POSTAL_CODE,
		icon: 'geography',
 		label: 'datasets.field.fieldType.postalCode',
		group: 'datasets.datatype.groups.geographic'
	}, {
		id: CITY,
		icon: 'geography',
 		label: 'datasets.field.fieldType.city',
		group: 'datasets.datatype.groups.geographic'
	}, {
	/* #49596 comment out Address geographic data type until supported
		id: 'address',
		icon: 'geography',
		label: 'datasets.field.fieldType.address',
		group: 'datasets.datatype.groups.geographic'
	}, { */
		id: CLUSTER,
		icon: CLUSTER,
		label: 'datasets.field.clusterFields.label.default'
	}, {
		id: FILE,
		icon: 'document-blank',
		label: 'common.file'
	}
	// #48265 initially unsupported geographic data types
	/*{
		id: 'voting-district',
		icon: 'geography',
		label: 'datasets.field.fieldType.votingDistrict',
		group: 'datasets.datatype.groups.geographic'
	}, {
		id: 'latitude',
		icon: 'geography',
		label: 'datasets.field.fieldType.latitude',
		group: 'datasets.datatype.groups.geographic'
	}, {
		id: 'longitude',
		icon: 'geography',
		label: 'datasets.field.fieldType.longitude',
		group: 'datasets.datatype.groups.geographic'
	}, {
	 	id: 'latitude-longitude',
		icon: 'geography',
		label: 'datasets.field.fieldType.latitudeLongitude',
		group: 'datasets.datatype.groups.geographic'
	}*/
]

const dataTypesById = _.keyBy(dataTypes, dataType => dataType.id)

export default dataTypes
export { dataTypesById }

dataTypes.__filename__ = 'datasets/edit/data-types.js'
